/** Owner: Pavit Gogia. Expiry: 2026-11-09. Cleanup: https://github.com/Borradh-Media/borradh-workspace/issues/1510. */
export const CLAIRE_DESIGNER_FLAG = 'rollout-claire-designer';
import { z } from 'zod';
export const publicSiteDomainSchema = z.object({
    hostname: z
        .string()
        .max(253)
        .regex(/^[a-z0-9.-]+$/),
    status: z.enum([
        'pending_dns',
        'verifying',
        'active',
        'error',
        'disconnecting',
    ]),
    records: z.array(z.object({
        type: z.enum(['A', 'CNAME', 'TXT']),
        name: z.string(),
        value: z.string(),
        purpose: z.enum(['routing', 'challenge']),
    })),
    error: z.string().nullable().default(null),
});
export const publicSiteViewSchema = z.object({
    configured: z.boolean(),
    imageUploadsEnabled: z.boolean().optional(),
    palette: z
        .object({
        background: z.string().regex(/^#[0-9a-fA-F]{6}$/),
        primary: z.string().regex(/^#[0-9a-fA-F]{6}$/),
        accent: z.string().regex(/^#[0-9a-fA-F]{6}$/),
    })
        .optional(),
    domain: publicSiteDomainSchema.nullable().optional(),
    hostingConfigured: z.boolean().default(true),
    publishing: z.boolean().default(false),
    publishingVersionId: z.string().nullable().default(null),
    publishError: z.string().nullable().default(null),
    status: z.enum(['empty', 'generating', 'interrupted', 'ready']),
    activeOperationId: z.string().nullable().default(null),
    error: z.string().nullable(),
    messages: z.array(z.object({
        id: z.string(),
        role: z.enum(['user', 'assistant']),
        content: z.string(),
        versionId: z.string().optional(),
    })),
    versions: z.array(z.object({
        id: z.string(),
        label: z.string(),
        createdAt: z.string(),
        verification: z
            .object({
            checkedAt: z.string(),
            mode: z.enum(['live', 'snapshot']),
        })
            .optional(),
    })),
    html: z.string().nullable(),
    publishedVersionId: z.string().nullable(),
    publicUrl: z.string().url().nullable(),
});
export const publicSitePreviewSchema = z.object({ html: z.string() });
//# sourceMappingURL=public-sites.js.map